import hyperdom from 'hyperdom'
import httpism from 'httpism/browser'
import range from 'lowscore/range.js'
import FeefoAdapter from 'root-packages/feefo/feefoAdapter.js'
import fakeFeefoAdapter from './../../../test/services/assemblies/adapters/fakeFeefoAdapterFactory.js'

export default class FeefoRating {
  constructor (options) {
    this.tourCode = options.departure.tourCode
    const feefoMerchantidentifier = options.config.feefoMerchantidentifier
    const feefoUrl = options.config.feefoUrl
    const adapterCtor = options.config.fakeFeefo ? fakeFeefoAdapter(options.config.fakeFeefo) : FeefoAdapter
    this.feefoAdapter = new adapterCtor({feefoMerchantidentifier, feefoUrl, httpClient: httpism})
    this.minimumTourRatingValue = 3
    this.minimumTourReviews = 10
    this.isFeefoRatingLoaded = false
    this.brandName = options.config.brandName
  }

  async onload () {
    try {
      let tourRating, tourReviewsUrl, numberOfReviews

      let response = await this.getProductRating()

      if (response) {
        tourRating = response.rating.rating
        numberOfReviews = response.meta.count
        tourReviewsUrl = response.product.reviews_url || response.merchant.review_url
      }

      if (this.minimumTourRatingValue < tourRating && this.minimumTourReviews < numberOfReviews) {
        this.rating = tourRating
        this.tourReviewsUrl = tourReviewsUrl
        this.isFeefoRatingLoaded = true
        return
      }

      response = await this.feefoAdapter.getMerchantRating()
      const merchantRating = response.rating.rating
      if (merchantRating > this.minimumTourRatingValue) {
        this.rating = merchantRating
        this.isMerchantRating = true
        this.tourReviewsUrl = response.merchant.review_url
        this.isFeefoRatingLoaded = true
      }
    } catch (error) {
      console.error(error)
    }
  }

  async getProductRating () {
    switch (this.brandName) {
    case 'Contiki':
      return await this.getParentRating()
    case 'Insight Vacations':
    case 'Luxury':
      return await this.getParentRating(`${this.tourCode.substring(0,4)}`)
    default:
      return await this.feefoAdapter.getProductRating(`${this.tourCode.substring(0,4)}*`)
    }
  }

  async getParentRating (parentCode) {
    const parentTourCode = parentCode || (await this.feefoAdapter.getParentTourCode(this.tourCode))
    return parentTourCode ? this.feefoAdapter.getParentRating(parentTourCode) : undefined
  }

  static renderRatingStars (rating) {
    return range(0, 5).map(index => {
      const starValue = rating - index

      const iconClass = starValue < 0.2
        ? '-new-ui_star_empty'
        : starValue >= 0.8
          ? '-new-ui_star'
          : '-new-ui_star_half'

      return <div class={iconClass}></div>
    })
  }

  static renderRating (rating, isMerchantRating, isFallbackRating, tourReviewsUrl) {
    return (
      <a href={tourReviewsUrl} target="_blank" class="product-rating">
        {isMerchantRating ? <div class="product-rating__service-label">Service Rating </div> : undefined}
        <div class="product-rating__stars">
          {FeefoRating.renderRatingStars(rating)}
        </div>
        {isFallbackRating ? undefined : <div class="product-rating__overall">{rating}</div>}
      </a>
    )
  }

  render () {
    const {isFeefoRatingLoaded, isMerchantRating, rating, tourReviewsUrl} = this

    return (!isFeefoRatingLoaded && typeof rating === 'undefined')
      ? FeefoRating.renderRating(5, false, true)
      : FeefoRating.renderRating(rating, isMerchantRating, false, tourReviewsUrl)
  }
}
